'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getAccentColor = require('conversations-schema/operators/coloring/getAccentColor');

var _wasSentInAwayMode = require('conversations-schema/pubnub-message/operators/wasSentInAwayMode');

var _isOfficeHoursEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isOfficeHoursEmailCapturePromptMessage');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _EmailCaptureChatBubble = require('./EmailCaptureChatBubble');

var _EmailCaptureChatBubble2 = _interopRequireDefault(_EmailCaptureChatBubble);

var _EmailCaptureForm = require('./EmailCaptureForm');

var _EmailCaptureForm2 = _interopRequireDefault(_EmailCaptureForm);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'EmailCapturePromptMessage',

  propTypes: {
    channel: _react.PropTypes.string,
    coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
    companyName: _react.PropTypes.string,
    consentToCommunicateMessage: _react.PropTypes.string,
    hasVisitorEmail: _react.PropTypes.bool.isRequired,
    message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
    requiresConsentToCommunicate: _react.PropTypes.bool,
    sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
    systemOnline: _react.PropTypes.bool.isRequired
  },

  handleSubmit: function handleSubmit(_ref) {
    var channel = _ref.channel,
        email = _ref.email,
        _ref$consentToCommuni = _ref.consentToCommunicate,
        consentToCommunicate = _ref$consentToCommuni === undefined ? false : _ref$consentToCommuni;

    this.setState({ emailSubmitted: true });

    return this.props.sendVisitorEmailAddress({
      channel: channel,
      email: email,
      consentToCommunicate: consentToCommunicate
    });
  },
  shouldShowCaptureMessage: function shouldShowCaptureMessage() {
    var message = this.props.message;

    return (0, _wasSentInAwayMode.wasSentInAwayMode)(message) || (0, _isOfficeHoursEmailCapturePromptMessage.isOfficeHoursEmailCapturePromptMessage)(message);
  },
  renderChatBubble: function renderChatBubble() {
    var _props = this.props,
        coloring = _props.coloring,
        message = _props.message;


    if (!this.shouldShowCaptureMessage()) {
      return _react2.default.createElement(_EmailCaptureChatBubble2.default, { coloring: coloring, message: message });
    }

    return null;
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      null,
      this.renderChatBubble(),
      _react2.default.createElement(
        'div',
        { className: 'm-left-7 m-right-1' },
        _react2.default.createElement(_EmailCaptureForm2.default, {
          buttonColor: (0, _getAccentColor.getAccentColor)(this.props.coloring),
          channel: this.props.channel,
          hasVisitorEmail: this.props.hasVisitorEmail,
          systemOnline: this.props.systemOnline,
          onSubmit: this.handleSubmit,
          text: (0, _pubnubMessageGetters.getRichText)(this.props.message),
          showCaptureMessage: this.shouldShowCaptureMessage(),
          companyName: this.props.companyName,
          requiresConsentToCommunicate: this.props.requiresConsentToCommunicate,
          consentToCommunicateMessage: this.props.consentToCommunicateMessage
        })
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/EmailCapturePromptMessage.js
// module id = 1088
// module chunks = 2 3